import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'

export const MainFooter = () => {
  const { pathname } = useLocation()
  // campaign create/edit pins a button bar (w/ prepay msg) over the right side of the footer
  const isCampaignFlow = /^\/campaigns\/(create|edit)/.test(pathname)

  return (
    <footer
      className={classNames(
        'MainFooter border-t-thin border-t-tint-gray-100 bg-base pointer-events-auto relative z-[100] flex h-full w-full items-center',
        isCampaignFlow ? 'justify-start pl-4' : 'justify-center',
      )}
    >
      <div
        className={classNames(
          'MainFooter__disclosures bg-base relative z-[100] flex flex-wrap items-center gap-x-3 py-2 text-xs font-light',
          isCampaignFlow ? 'justify-start' : 'justify-center',
        )}
      >
        <span className="Copyright__year">
          &copy; {new Date().getFullYear()} El Toro
        </span>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link
          to="https://eltoro.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link to="/aup">Acceptable Use Policy</Link>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link to="/dpa">Data Processing Agreement</Link>
      </div>
    </footer>
  )
}
